import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {RealTimeRecord} from '../../model/real-time.model';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { DeviceOpt } from 'src/app/client-management/statistical/technical-data/technical-data';

@Injectable({
  providedIn: 'root'
})
export class RealTimeStateService {

  private recordsSubject = new BehaviorSubject<Map<number, RealTimeRecord>>(new Map());
  private oldRecordsSubject = new BehaviorSubject<Map<number, RealTimeRecord>>(new Map());
  private selectedDeviceSubject = new BehaviorSubject<number>(0);
  private deviceOptSubject = new BehaviorSubject<DeviceOpt[]>([]);

  constructor() {}

  // =========================== RECORDS START ===================================
  setRecord(deviceId: number, record: RealTimeRecord): void {
    const currentMap = this.recordsSubject.value;
    currentMap.set(deviceId, record);
    this.recordsSubject.next(new Map(currentMap));
  }

  getRecord(deviceId: number): Observable<RealTimeRecord | undefined> {
    return this.recordsSubject.asObservable()
    .pipe(map(map => map.get(deviceId)),filter((record): record is RealTimeRecord => record !== undefined) , distinctUntilChanged());
  }
  // =========================== RECORDS END ======================================


  // ===========================  OLD RECORDS START ===================================
  setOldRecord(deviceId: number, record: RealTimeRecord): void {
    const currentMap = this.oldRecordsSubject.value;
    currentMap.set(deviceId, record);
    this.oldRecordsSubject.next(new Map(currentMap));
  }

  getOldRecord(deviceId: number): RealTimeRecord | undefined {
    return this.oldRecordsSubject.getValue()?.get(deviceId);
  } 
  // =========================== OLD RECORDS END ======================================

  // =========================== SELECTED DEVICE START ===================================
  setSelectedDevice(deviceId:number){
    this.selectedDeviceSubject.next(deviceId);
  }

  getCurrentSelectedDevice(){
    return this.selectedDeviceSubject.getValue();
  }
  // =========================== SELECTED DEVICE END =======================================


  // =========================== DEVICE OPT START =======================================
  setDeviceOpts(value: DeviceOpt[]) {
    this.deviceOptSubject.next(value);
  }

  getCurrentDeviceOpts(): DeviceOpt[] {
    return this.deviceOptSubject.getValue();
  }

  getDeviceOptById(idDevice: number): DeviceOpt | undefined {
    return this.getCurrentDeviceOpts().find(opt => opt.idDevice === idDevice);
  }
  // =========================== DEVICE OPT END =======================================
}
